import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="row">
          <div className="col-12 section-title text-center">
            <h2>O que nossos clientes tem a dizer:</h2>
          </div>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-12 col-md-4">
                  <div className="testimonial">
                    {/* <div className="testimonial-image">
                      <img src={d.img} alt="" />
                    </div> */}
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta">- {d.name}</div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
